module.exports = __webpack_public_path__ + "img/sc.98c17e12.png";